module.exports = __webpack_public_path__ + "img/about_yourself.2d350b84.svg";